export enum ToastTypes {
  success = 0,
  error = 1,
  info = 2,
}
